import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FinalCta } from "@/components/FinalCta";
import { SEOHead } from "@/components/SEOHead";
import { Link } from "@/lib/router-compat";

// ---------------------------------------------------------------------------
// NOSOTROS — "Menos humo, más resultados." + Seguridad y confianza.
// ---------------------------------------------------------------------------

const equipo = [
  {
    nombre: "Tomo Garat",
    cargo: "CEO",
    desc: "Ventas, estrategia y marca.",
    foto: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9f0b20bcef8b5f2c2c29f7.jpeg",
  },
  {
    nombre: "Mateo Garat",
    cargo: "COO",
    desc: "Operaciones, implementaciones y atención al cliente.",
    foto: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9f0b201543e1ae08b11ada.jpeg",
  },
  {
    nombre: "Manuel Otero",
    cargo: "CTO",
    desc: "Desarrollo y tecnología.",
    foto: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9f0b20bbc6015019c2ab7e.png",
  },
];

const valores = [
  {
    t: "Nos importa",
    d: "Estamos en el negocio de que nos importe. Y el negocio anda viento en popa.",
  },
  {
    t: "Humor",
    d: "Nos tomamos en serio los resultados. Nuestras reuniones de equipo, no tanto.",
  },
  {
    t: "Genuinos",
    d: "Hablamos como somos y actuamos en consecuencia. Lo demás es careta.",
  },
  {
    t: "Humildad",
    d: "Somos perfectos, nunca nos equivocamos, ¿no? (Pero si pasa, lo arreglamos al toque).",
  },
  {
    t: "Palabra",
    d: "Cuando decimos que vamos a hacer algo, lo hacemos. Así de simple.",
  },
];

const trust = [
  {
    n: "01",
    title: "Quiénes somos",
    body: "CreceLocal es operado por CreceLocal LLC, sociedad registrada en Delaware, Estados Unidos. Equipo en Buenos Aires, Argentina.",
  },
  {
    n: "02",
    title: "Con qué trabajamos",
    body: "Proveedores establecidos con integraciones oficiales: Google, Meta, WhatsApp e Instagram. Nada experimental sobre tu negocio.",
  },
  {
    n: "03",
    title: "Qué hacemos con tus datos",
    body: "Tu información se usa para configurar y mantener tu sistema. No la compartimos ni la vendemos. Accedés y pedís baja cuando quieras.",
  },
  {
    n: "04",
    title: "Cómo te respaldamos",
    body: "Garantía de 30 días y soporte por WhatsApp con gente real. Si no ves una mejora real, te devolvemos tu inversión.",
  },
];

const tools = [
  {
    name: "Google",
    logo: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9e0276ca6e04d2301f73d3.svg",
  },
  {
    name: "Meta",
    logo: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9e0278b81a3502a88f15b8.svg",
  },
  {
    name: "WhatsApp",
    logo: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9e0277b81a3502a88f15ae.svg",
  },
  {
    name: "Instagram",
    logo: "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/6a9e0278b81a3502a88f15b8.svg",
  },
];

const legal = [
  { t: "Términos", href: "/terminos" },
  { t: "Privacidad", href: "/privacidad" },
  { t: "Reembolsos", href: "/reembolso" },
  { t: "Tus datos", href: "/tus-datos" },
];

const Nosotros = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Nosotros — Menos humo, más resultados | CreceLocal"
        description="Conocé al equipo de CreceLocal: sistemas de marketing accesibles y sin vueltas para empresas de servicios y distribuidores. Equipo, valores, seguridad y confianza."
        canonical="/nosotros"
      />
      <Navbar />
      <main>
        {/* Intro */}
        <section
          className="mx-auto px-6 grid"
          style={{
            maxWidth: 1240,
            paddingTop: "clamp(72px,9vw,120px)",
            paddingBottom: 72,
            gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,440px),1fr))",
            gap: 48,
          }}
        >
          <div>
            <div
              className="font-mono text-[13px] text-[#A78BFA]"
              style={{ letterSpacing: "0.08em" }}
            >
              NOSOTROS
            </div>
            <h1
              className="font-medium text-[#EEEDF2] mt-5"
              style={{
                fontSize: "clamp(44px,6.6vw,92px)",
                lineHeight: 0.98,
                letterSpacing: "-0.03em",
              }}
            >
              Menos humo,{" "}
              <span
                style={{
                  background: "linear-gradient(90deg,#A78BFA,#E879F9)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                }}
              >
                más resultados.
              </span>
            </h1>
          </div>
          <div
            className="flex flex-col gap-[18px]"
            style={{
              fontSize: 17,
              lineHeight: 1.65,
              color: "#BAB6C4",
              paddingTop: 8,
            }}
          >
            <p>
              Vimos a demasiadas agencias enterrar a dueños de empresas de
              servicios en anglicismos y términos técnicos, haciendo parecer que
              lo básico es una ciencia. El marketing no tiene que ser
              complicado, ni salirte una fortuna porque alguien lo hace sonar
              sofisticado.
            </p>
            <p>
              Armamos CreceLocal para ofrecer sistemas accesibles y sin vueltas:
              una base sólida para crecer, mientras vos te ocupás de tu negocio.
            </p>
            <p
              className="text-[14.5px] text-[#9C98A6]"
              style={{ borderTop: "1px solid #221F2A", paddingTop: 18 }}
            >
              CreceLocal es operado por CreceLocal LLC, sociedad registrada en
              Delaware, Estados Unidos. Equipo en Buenos Aires, Argentina.
            </p>
          </div>
        </section>

        {/* Equipo */}
        <section
          className="mx-auto px-6"
          style={{ maxWidth: 1240, paddingBottom: 80 }}
        >
          <h2
            className="font-semibold text-[#EEEDF2]"
            style={{ fontSize: 24, letterSpacing: "-0.02em" }}
          >
            El equipo
          </h2>
          <div
            className="grid mt-6"
            style={{
              gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
              gap: 20,
            }}
          >
            {equipo.map((p) => (
              <div
                key={p.nombre}
                className="border border-[#221F2A] rounded-2xl overflow-hidden bg-[#13111A]"
              >
                <div
                  className="overflow-hidden bg-[#1A1722]"
                  style={{ aspectRatio: "1 / 1" }}
                >
                  <img
                    src={p.foto}
                    alt={`Foto de ${p.nombre}`}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="px-5 py-[18px]">
                  <div className="flex justify-between">
                    <span className="font-semibold text-[#EEEDF2]">
                      {p.nombre}
                    </span>
                    <span className="font-mono text-[12px] text-[#A78BFA]">
                      {p.cargo}
                    </span>
                  </div>
                  <div className="text-[14.5px] text-[#9C98A6] mt-1">
                    {p.desc}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Valores */}
        <section className="bg-[#0F0D14] border-t border-[#221F2A]">
          <div
            className="mx-auto px-6"
            style={{ maxWidth: 1240, paddingTop: 72, paddingBottom: 96 }}
          >
            <h2
              className="font-semibold text-[#EEEDF2]"
              style={{ fontSize: 24, letterSpacing: "-0.02em" }}
            >
              Cómo trabajamos
            </h2>
            <div
              className="grid mt-7"
              style={{
                gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
                gap: 20,
              }}
            >
              {valores.map((v) => (
                <div
                  key={v.t}
                  style={{ borderTop: "1px solid #A78BFA", paddingTop: 18 }}
                >
                  <h3
                    className="font-semibold text-[#EEEDF2]"
                    style={{ fontSize: 17 }}
                  >
                    {v.t}
                  </h3>
                  <p
                    className="text-[14.5px] text-[#9C98A6] mt-1.5"
                    style={{ lineHeight: 1.5 }}
                  >
                    {v.d}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Seguridad y confianza */}
        <section
          className="mx-auto px-6"
          style={{
            maxWidth: 1240,
            paddingTop: "clamp(72px,9vw,120px)",
            paddingBottom: 56,
          }}
        >
          <div
            className="font-mono text-[13px] text-[#A78BFA]"
            style={{ letterSpacing: "0.08em" }}
          >
            SEGURIDAD Y CONFIANZA
          </div>
          <h1
            className="font-medium text-[#EEEDF2] mt-5"
            style={{
              fontSize: "clamp(44px,6.6vw,92px)",
              lineHeight: 0.98,
              letterSpacing: "-0.03em",
              maxWidth: 1000,
              textWrap: "balance" as never,
            }}
          >
            Quiénes somos, con qué trabajamos y qué hacemos con tus datos.
          </h1>
        </section>

        <section
          className="mx-auto px-6"
          style={{ maxWidth: 1240, paddingBottom: 80 }}
        >
          <div
            className="grid gap-px bg-[#221F2A] border border-[#221F2A] rounded-2xl overflow-hidden"
            style={{
              gridTemplateColumns:
                "repeat(auto-fit,minmax(min(100%,300px),1fr))",
            }}
          >
            {trust.map((t) => (
              <div key={t.n} className="bg-[#0F0D14] p-8">
                <div className="font-mono text-[12px] text-[#6E6A7A]">
                  {t.n}
                </div>
                <h2
                  className="font-semibold text-[#EEEDF2] mt-4"
                  style={{ fontSize: 20, letterSpacing: "-0.01em" }}
                >
                  {t.title}
                </h2>
                <p
                  className="text-[#9C98A6] mt-2.5"
                  style={{ lineHeight: 1.6, textWrap: "pretty" as never }}
                >
                  {t.body}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Herramientas */}
        <section className="bg-[#0F0D14] border-t border-b border-[#221F2A]">
          <div
            className="mx-auto px-6"
            style={{ maxWidth: 1240, paddingTop: 72, paddingBottom: 72 }}
          >
            <h2
              className="font-semibold text-[#EEEDF2]"
              style={{ fontSize: 24, letterSpacing: "-0.02em" }}
            >
              Herramientas sobre las que está construido
            </h2>
            <p className="text-[#9C98A6] mt-2">
              Proveedores establecidos, con integraciones oficiales.
            </p>
            <div
              className="grid mt-7 gap-px bg-[#221F2A] border border-[#221F2A] rounded-xl overflow-hidden"
              style={{
                gridTemplateColumns: "repeat(auto-fill,minmax(180px,1fr))",
              }}
            >
              {tools.map((t) => (
                <div
                  key={t.name}
                  className="bg-[#0A090D] p-5 flex gap-2.5 items-center text-[14px] text-[#BAB6C4]"
                >
                  <img
                    src={t.logo}
                    alt=""
                    className="grayscale brightness-200"
                    style={{ width: 22, height: 22, objectFit: "contain" }}
                  />
                  {t.name}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Legal */}
        <section
          className="mx-auto px-6"
          style={{ maxWidth: 1240, paddingTop: 72, paddingBottom: 96 }}
        >
          <h2
            className="font-semibold text-[#EEEDF2]"
            style={{ fontSize: 24, letterSpacing: "-0.02em" }}
          >
            Documentos legales
          </h2>
          <p className="text-[#9C98A6] mt-2">
            Públicos, para leer antes de contratar.
          </p>
          <div
            className="grid mt-6"
            style={{
              gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
              gap: 12,
            }}
          >
            {legal.map((l) => (
              <Link
                key={l.t}
                to={l.href}
                className="flex justify-between items-center px-[22px] py-5 border border-[#221F2A] rounded-xl bg-[#13111A] text-[#EEEDF2] font-medium hover:border-[#433C52] transition-colors"
              >
                {l.t}
                <span className="text-[#A78BFA]">↗</span>
              </Link>
            ))}
          </div>
        </section>

        <FinalCta />
      </main>
      <Footer />
    </div>
  );
};

export default Nosotros;
